import { memo } from 'react'

import Support from './Support'

const SupportComponent = memo(Support)

export default SupportComponent
